<template>
  <div id="map"></div>
</template>

<script>
export default {
  name: 'Map',
  data () {
    return {}
  },
  mounted () {
    this.initMap()
  },
  methods: {
    initMap () {
      var center = new window.TMap.LatLng(22.579472, 114.116386)
      // 114.122605,22.585814
      // eslint-disable-next-line
      var map = new window.TMap.Map(document.getElementById('map'), {
        center: center,
        zoom: 18,
        zoomControl: 0, // 绽放控件
        panControl: 0 // 平移控件
      })
      // eslint-disable-next-line
      var marker = new window.TMap.MultiMarker({
        id: 'marker-layer',
        map: map,
        styles: {
          marker: new window.TMap.MarkerStyle({
            width: 45,
            height: 45,
            anchor: { x: 16, y: 32 },
            src:
              'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerNew.png'
          })
        },
        geometries: [
          {
            id: 'demo',
            styleId: 'marker',
            position: new window.TMap.LatLng(22.579472, 114.116386),
            properties: {
              title: 'marker'
            }
          }
        ]
      })
      // eslint-disable-next-line
      var infoWindow = new window.TMap.InfoWindow({
        map: map,
        position: center,
        offset: { x: 5, y: -38 },
        content:
          '<h3 style="margin-bottom: 10px;text-align: left;color: #05579e;">GeneMind Biosciences Co., Ltd.</h3><div style="text-align: left;display: flex;width: 380px;"><div style="margin-right:15px;display: flex;flex-direction: column;justify-content: space-between;"><p>Address:</p><p class="left-phone">Tel：</p></div><div style="display: flex;flex-direction: column;justify-content: space-between;"><p style="white-space: pre-wrap;">5F and 6F, Block 2, Luohu Investment Holding Building, No. 116, Qingshuihe 1st Road, Luohu District, Shenzhen, Guangdong, China</p><p>+86-400-822-3660</p></div></div>'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#map {
  height: vw(624);
  width: vw(1200);
}
</style>



// WEBPACK FOOTER //
// src/components/map.vue